import script from "./FullPageLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./FullPageLoader.vue?vue&type=script&setup=true&lang=js"

import "./FullPageLoader.vue?vue&type=style&index=0&id=08d58e3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d58e3f"]])

export default __exports__